<template >
    <div>
        <portafolio/>
    </div>
</template>

<script>
import Portafolio from '../components/portafolioComponent'
export default {
      components:{
        Portafolio
    }
}
</script>